import { useTheme } from '@fable/theme'

const PauseIcon: React.VFC<{ color?: string }> = ({ color }) => {
  const { colors } = useTheme()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      className="pause-icon"
    >
      <path
        fill={color ? color : colors.blackSwan}
        d="M19,0A19,19,0,1,0,38,19,19,19,0,0,0,19,0ZM17,25.5a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1v-13a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm8,0a1,1,0,0,1-1,1H22a1,1,0,0,1-1-1v-13a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Z"
      />
    </svg>
  )
}

export default PauseIcon
